// extracted by mini-css-extract-plugin
export var large = "service-template-large-module--large--3Z8IU";
export var image = "service-template-large-module--image--9j3qF";
export var text = "service-template-large-module--text--10ugr";
export var orderName = "service-template-large-module--orderName--2np0B";
export var description = "service-template-large-module--description--3JnyK";